import { Component, ElementRef, OnInit, ViewChild, Inject } from '@angular/core';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestService } from '../services/request.service';
import { ProductService } from '../services/product.service';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith, filter } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent, MatChipInputEvent, MatAutocomplete, MatDialog, MatDialogRef, MAT_DIALOG_DATA, DateAdapter, MatSnackBar, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { ClientService } from '../services/client.service';
import { PackageService } from '../services/package.service';
import { Overlay } from '@angular/cdk/overlay';
import { DocumentService } from '../services/document.service';
import { ActionsService } from '../services/actions.service';
import {MomentDateAdapter} from '@angular/material-moment-adapter';


export interface ClientModal {
  name: string;
  eik: string;
  dds: number;
  address: string;
  city: string;
  mol: string;
  discount: string;
  contract: boolean;

}

export interface IndicatorData {
  selectedIds: any;
}

export const MY_FORMATS = {
  parse: {
    dateInput: 'YYYY',
  },
  display: {
    dateInput: 'YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};


@Component({
  selector: 'app-request-insert',
  templateUrl: './request-insert.component.html',
  styleUrls: ['./request-insert.component.css'],
  providers:[
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class RequestInsertComponent implements OnInit {
  id: number;
  submitted: boolean;
  routeId: number;
  clients: any;
  products: any;
  vinolabReqId:any;
  subProducts: any;
  subSubProducts: any;
  client_name: string;
  client_id: any;
  product_id: number;
  package_id: number;
  subProduct_id: number;
  subSubProduct_id: number;
  sort: string;
  sort_en: string;
  sort_ru: string;
  batch: string;
  vintage: any;
  declaration:any;
  sample_protocol:boolean;
  sample_number:string;
  sample_address:string;
  quantity_count: number;
  additional_notes: string;
  get_protocol: string;
  express_order: boolean;
  standpoint: number;
  standpointPages: number;
  subShow: boolean;
  packageShow: boolean;
  subSubShow: boolean;
  quantity: number;
  indicators: any;
  price_all: number;
  checked_indicators: any;
  reference_number: number;
  created_at: any;
  object = [];
  myControl = new FormControl();
  filteredOptions: Observable<any>;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  fruitCtrl = new FormControl();
  filteredFruits: Observable<any>; // filtered indicators
  selIndicators: any = []; //selected indicators
  allIndicators: any = [];
  selIndicatorIds: any = [];
  vinolabReq: false;
  selectedClient: any = [];
  protocol_lang: any = [];
  courier: string;
  payment_type: string;
  status: string;
  bg: boolean;
  en: boolean;
  ru: boolean;
  courier_name: string;
  packages: any;
  paid_part: string;
  statusText: string;
  modalIndicators: any = [];
  proggress:number;
  batch_quantity:string;
  product_info:string;

  //protocol data
  protocol_town: string;
  protocol_phone: string;
  protocol_address: string;
  protocol_person: string;

  //docs
  allDocs: any;
  invoice_id: any;
  proforma_id: any;
  kreditno_id: any;
  debitno_id: any;
  requestDoc_id: any;
  protocol_id:any;
  addDoc:any;
  editDoc:any;
  deleteDoc:any;

  matForm: any;
  maxDate: any = new Date(); // max vintage date
  token:string = localStorage.getItem('token');

  @ViewChild('fruitInput') fruitInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;

  constructor(private requestService: RequestService,
    private productService: ProductService,
    private packageService: PackageService,
    private actionService: ActionsService,
    private route: ActivatedRoute,
    private router: Router,
    private overlay: Overlay,
    public snackBar: MatSnackBar,
    public clientService: ClientService,
    private documentService: DocumentService,
    private dateAdapter: DateAdapter<Date>,
    public dialog: MatDialog) {
    this.getClients();
    this.getProducts();
    this.getDocumentActions();
    dateAdapter.setLocale('en-in');
    if (this.routeId != 0) {
      
      if (!this.price_all) {
        this.price_all = 0;
      }
      if (!this.quantity_count) {
        this.quantity_count = 1;
      }
      if (!this.get_protocol) {
        this.get_protocol = "place";
      }

    } else {
      this.client_id = null;
      this.quantity_count = 1;
      this.get_protocol = "place";
      this.payment_type = "cash";
      this.sample_protocol = false;
      this.price_all = 0;
    }
  }

  public loading = false;

  ngOnInit() {
    this.routeId = +this.route.snapshot.paramMap.get('id');
    if (this.routeId != 0) {
      this.id = +this.route.snapshot.paramMap.get('id');
      this.editRequest(this.routeId);
    } else {
      this.getReferenceNumber();
      this.protocol_id = 0;
    }
    this.matForm = document.getElementById("matForm");
  }


  chosenYearHandler(event) {
    var year = event._i.year;
    this.vintage = new Date(year+'-01-01');
    // picker.close();
  }


  generateVinoLabReq(){
    var data = {
      vinolabReq:this.vinolabReqId,
      reqId:this.id
    }
    this.requestService.generateVinolabReq(data).subscribe(resp =>{
      if(resp){
        this.editRequest(resp);
      }else{
        this.openSnackBar('Заявка с този номер не съществува', null);
      }
      
    });
  }

  checkPaidPart(price) {
    if (this.price_all < parseFloat(price)) {
      this.paid_part = '0';
    }
  }

  getDocumentActions() {
    this.actionService.moduleAction(11).subscribe(data => {
      this.addDoc = data.add_action;
      this.editDoc = data.edit_action;
      this.deleteDoc = data.delete_action;
    });
  }

  //modal
  openDialog(): void {
    const dialogRef = this.dialog.open(ClientModal, {
      width: '600px',
      data: {
        contract: 0,
        discount: '',
        dds: 1
      }

    });

    dialogRef.afterClosed().subscribe(clientForm => {
      var formData = {
        bg: {
          name: clientForm.name,
          eik: clientForm.eik,
          discount: clientForm.discount,
          address: clientForm.address,
          city: clientForm.city,
          dds: clientForm.dds,
          mol: clientForm.mol,
          phone: clientForm.phone,
          contract: clientForm.contract,
          email: clientForm.email,
          contact: clientForm.contact,
          doc_address: clientForm.doc_address
        },
        en: {
          name: clientForm.name_en,
          eik: clientForm.eik,
          discount: clientForm.discount,
          address: clientForm.address_en,
          city: clientForm.city_en,
          dds: clientForm.dds,
          mol: clientForm.mol_en,
          phone: clientForm.phone_en,
          contract: clientForm.contract,
          email: clientForm.email_en,
          contact: clientForm.contact_en,
          doc_address: clientForm.doc_address_en
        },
        ru: {
          name: clientForm.name_ru,
          eik: clientForm.eik,
          discount: clientForm.discount,
          address: clientForm.address_ru,
          city: clientForm.city_ru,
          dds: clientForm.dds,
          mol: clientForm.mol_ru,
          phone: clientForm.phone_ru,
          contract: clientForm.contract,
          email: clientForm.email_ru,
          contact: clientForm.contact_ru,
          doc_address: clientForm.doc_address_ru
        }
      };
      if (clientForm) {
        this.clientService.saveClient(formData).subscribe(data => {
          this.clientSelected(data.name + " - " + data.eik);
          this.client_name = data.name + " - " + data.eik;
        });
      }


    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000,
    });
  }

  addProtocolLang(name) {
    console.log(name);
    this.documentService.checkLangPossibility(this.id,name).subscribe(data=>{
        // console.log(data);
        if(data == 1){
          if (this.protocol_lang != null) {
            const index = this.protocol_lang.indexOf(name);
            if (index >= 0) {
              this.protocol_lang.splice(index, 1);
            } else {
              this.protocol_lang.push(name);
            }
          } else {
            this.protocol_lang = [name]
          }
          this.getIndicatorPrice();
        }else{
          if(name == 'bg'){
            if(this.bg && data != null){
              this.openSnackBar(data,null);
            }
            this.bg = false;
          }else if(name == 'en'){
            if(this.en && data != null){
              this.openSnackBar(data,null);
            }
            this.en = false;
          }else{
            if(this.ru && data != null){
              this.openSnackBar(data,null);
            }
            this.ru = false;
          }
        }
    });
    
  }



  add(event: MatChipInputEvent): void {
    // Add fruit only when MatAutocomplete is not open
    // To make sure this does not conflict with OptionSelected Event
    if (!this.matAutocomplete.isOpen) {
      const input = event.input;
      const value = event.value;

      // Add our fruit
      if ((value || '').trim()) {
        this.selIndicators.push({
          id: Math.random(),
          name: value.trim()
        });
      }

      // Reset the input value
      if (input) {
        input.value = '';
      }



      this.fruitCtrl.setValue(null);
      this.getIndicatorPrice();
    }
  }

  remove(indicator): void {
    this.package_id = 0;
    const index = this.selIndicators.indexOf(indicator);
    const idIndex = this.selIndicatorIds.indexOf(indicator.id);
    const allIndicatorIndex = this.allIndicators.indexOf(indicator);
    
    this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
      startWith(null),
      map((fruit: string | null) => fruit ? this._filterChip(fruit) : this.allIndicators.slice())
    );

    if (index >= 0) {
      this.selIndicators.splice(index, 1);
      this.selIndicatorIds.splice(idIndex, 1);
      this.allIndicators.push(indicator);
    }
    this.getIndicatorPrice();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.package_id = 0;
    this.selIndicators.push(event.option.value);
    this.selIndicatorIds.push(event.option.value.id);
    var index = this.allIndicators.indexOf(event.option.value);
    if (index !== -1) {
      this.allIndicators.splice(index, 1);
    }
    this.fruitInput.nativeElement.value = '';
    this.fruitCtrl.setValue(null);


    this.matForm.classList.remove('mat-focused')
    this.getIndicatorPrice();

  }



  private _filterChip(value): string[] {
    var filterValue = "";
    if(typeof value == "string"){
       filterValue = value.toLowerCase();
    }else{
       filterValue = value.name.toLowerCase();
    }
    return this.allIndicators.filter(fruit => fruit.name.toLowerCase().indexOf(filterValue) === 0);
  }


  private _filter(value: string): string[] {
    if (value != null) {
      const filterValue = value.toLowerCase();
      return this.clients.filter(clients => clients.toLowerCase().includes(filterValue));
    }



  }

  clientSelected(name) {
    if (name != null) {
      this.requestService.clientInfo(name).subscribe(data => {
        this.client_name = name;
        this.selectedClient = data;
        if(this.protocol_town == '' || this.protocol_town === undefined){
          this.protocol_town = this.selectedClient.city;
        }
        if(this.protocol_address == '' || this.protocol_address === undefined){
          this.protocol_address = this.selectedClient.doc_address;
        }
        if(this.protocol_phone == '' || this.protocol_phone === undefined){
          this.protocol_phone = this.selectedClient.phone;
        }
        if(this.protocol_person == '' || this.protocol_person === undefined){
          this.protocol_person = this.selectedClient.mol;
        }
        if (this.selectedClient.contract == 1) {
          this.packageShow = false;
          this.package_id = 0;
          this.getIndicatorPrice();
        } else {
          this.packageShow = true;
        }
      });
    }

  }





  submit(requestForm) {
    if (this.protocol_lang.length == 0) {
      this.protocol_lang = ['bg']; // Ако не е селектиран език автоматично селектира бг и добавя 6 лв
      this.price_all += 6;
    }
    if(this.vintage != null){
      this.vintage = new Date(this.vintage).toLocaleDateString('en-GB');
    }


    if(this.declaration != null){
      this.declaration = new Date(this.declaration).toLocaleDateString('en-GB');
    }
    var data = {
      id: this.id,
      checked_indicators: this.selIndicatorIds,
      sort: this.sort,
      sort_ru: this.sort_ru,
      sort_en: this.sort_en,
      batch: this.batch,
      additional_notes: this.additional_notes,
      get_protocol: this.get_protocol,
      express_order: this.express_order,
      price_all: this.price_all,
      product_id: this.product_id,
      package_id: this.package_id,
      subProduct_id: this.subProduct_id,
      subSubProduct_id: this.subSubProduct_id,
      standpoint: this.standpoint,
      quantity_count: this.quantity_count,
      quantity: this.quantity,
      vintage: this.vintage,
      reference_number: this.reference_number,
      client_id: this.selectedClient.id,
      client_name: this.selectedClient.name,
      batch_quantity:this.batch_quantity,
      protocol_lang: this.protocol_lang,
      courier: this.courier,
      standpointPages:this.standpointPages,
      courier_name: this.courier_name,
      status: this.status,
      payment_type: this.payment_type,
      paid_part: this.paid_part,
      protocol_town: this.protocol_town,
      protocol_address: this.protocol_address,
      protocol_phone: this.protocol_phone,
      protocol_person: this.protocol_person,
      product_info:this.product_info,
      sample_protocol:this.sample_protocol,
      sample_address:this.sample_address,
      sample_number:this.sample_number,
      declaration:this.declaration

    }



    if(this.selIndicatorIds.length > 0){
      this.requestService.saveRequest(data).subscribe(data1 => {
        this.submitted = true;
        this.editRequest(this.id);
        this.openSnackBar('Успешно запазена заявка', null);
      });
    }else{
      this.openSnackBar('Добавете поне един показател', null);
    }
    

  }

  getReferenceNumber() {
    this.requestService.getReferenceNumber().subscribe(data => {
      this.id = data.id;
      this.reference_number = data.reference_number;
      this.created_at = data.created_at;
      this.standpoint = data.standpoint;
      this.express_order = data.express_order;
      this.payment_type = data.payment_type;
      this.status = data.status.toString();

    });
  }

  getClients() {
    this.requestService.getClients().subscribe(data => {
      this.clients = data;
      this.filteredOptions = this.myControl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filter(value))
        );
    });

    return this.clients;
  }

  getPackages(id) {
    if (this.selectedClient.contract != 1) {
      this.packageService.getProdPackage(id).subscribe(data => {
        this.packageShow = true;
        this.packages = data;
      })
    } else {
      this.packageShow = false;
    }
  }

  getPackIndicators(id) {
    if (id != 0) {
      this.packageService.getPackageIndicators(id).subscribe(data => {
        this.selIndicators = data;
        this.selIndicatorIds = [];
        data.forEach(element => {
          var index = this.allIndicators.indexOf(element.name);

          this.selIndicatorIds.push(element.id);


          if (index !== -1) {
            this.allIndicators.splice(index, 1);
          }
        }); 
        this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
          startWith(null),
          map((fruit: string | null) => fruit ? this._filterChip(fruit) : this.allIndicators.slice())
        );
        this.getIndicatorPrice();
      });
    } else {
      this.selIndicators = [];
      this.selIndicatorIds = [];
      this.getIndicatorPrice();
    }

  }

  getProducts() {
    this.productService.getProducts().subscribe(data => {
      this.products = data;
      this.product_id = 0;
    });

    return this.products;
  }

  getSubProds(id) {
    const routeId = +this.route.snapshot.paramMap.get('id');
    this.productService.getSubProducts(id).subscribe(data => {
      this.subProducts = data;
      // this.selIndicatorIds = [];
      // this.selIndicators = [];//tuka
      if (routeId == 0) {
        this.subProduct_id = 0;
      }
      if (id != 0) {
        this.getIndicators(id);
        this.getPackages(id);
        this.subShow = true;
        this.subSubShow = false;
      } else {
        this.subShow = false;
        this.packageShow = false;
        this.subSubShow = false;
      }
    });
  }

  getSubSubProds(id) {
    const routeId = +this.route.snapshot.paramMap.get('id');
    this.productService.getSubProducts(id).subscribe(data => {
      this.subSubProducts = data;
      if (this.subSubProducts.length > 0) {
        if (routeId == 0) {
          this.subSubProduct_id = 0;
        }

        if (id != 0) {
          
          this.subSubShow = true;
        } else {
          
          this.subSubShow = false;
        }
      }

    });
  }


  getIndicatorPrice() {
   
    if (this.package_id === undefined) {
      this.package_id = 0;
    }
    
    this.requestService.getIndicatorPrice(this.selIndicatorIds, this.package_id).subscribe(data => {
      
      this.price_all = data.indicators;
      this.package_id = parseInt(data.package);
      if (this.standpoint == 1) {
        this.price_all += 120;
      } else if (this.standpoint == 2) { //Допълнително поле за вкарване на брой страници за становище
        // 120 за 2 страници от становището и всяка следваща по 60 лв
        if(!this.standpointPages || this.standpointPages < 3){
          this.standpointPages = 3;
        }
        if (this.standpointPages >= 2) {
          this.price_all += ((this.standpointPages - 2) * 60) + 120;
        } else {
          this.price_all += 120;
        }
      }

      if (this.bg) {
        this.price_all += 6;
      }

      if (this.en) {
        this.price_all += 10;
      }

      if (this.ru) {
        this.price_all += 10;
      }

      if (this.express_order) {
        this.price_all = this.price_all + ((this.price_all * 50) / 100);
      }
    });
  }

  getIndicators(id) {
    this.productService.getIndicators(id).subscribe(data => {
      this.indicators = data;
      this.allIndicators = data;
      // this.selIndicators.forEach(element => {
      //   console.log(this.allIndicators.indexOf(element));
      // });
      this.filteredFruits = this.fruitCtrl.valueChanges.pipe(
        startWith(null),
        map((fruit: string | null) => fruit ? this._filterChip(fruit) : this.allIndicators.slice())
      );

    });

  }

  getInvoiceJson(type) {
    this.loading = true;
    var data = {
      requestId: this.id,
      user_id: localStorage.getItem('user_id'),
      client_id: this.selectedClient.id
    }
    this.documentService.generateDoc(type, data).subscribe(data => {
      this.allDocs = data.allDocs;
      if (data.invoice_id != undefined && type == 2) {
        this.invoice_id = data.invoice_id;
      }else if(data.invoice_id != undefined && type == 3){
        this.proforma_id = data.invoice_id;
      }
      this.submit({});
      this.loading = false;
    });
  }


  getGeneratedDocs(id) {
    this.documentService.generatedDocs(id).subscribe(data => {
      // console.log(data,'tuka');
    });
  }


  //url tuk
  getRequestDoc() {
    this.loading = true;
    var data = {
      user_id: localStorage.getItem('user_id'),
      request_id: this.requestDoc_id
    }
    this.documentService.generateReqDoc(this.id, data).subscribe(resp => {
      const link = document.createElement('a');
      link.target = '_blank';
      link.href = "https://niivsnes.humge.com/api/requestDocument/" + resp + "/0?token="+this.token;
      link.setAttribute('visibility', 'hidden');
      link.click();
      setTimeout(() =>
        window.open("https://niivsnes.humge.com/api/requestDocument/" + resp + "/0?token="+this.token, '_blank')
        , 1000);
      this.submit({});
      this.loading = false;
    });
  }

  getRequestProtocol() {
    var data = {
      protocol_id:this.protocol_id
    }
    this.loading = true;
    this.documentService.generateReqProtocol(this.id, data).subscribe(resp => {
      // if(resp == null){
      //   this.openSnackBar("Липсва нужната информация за издаване на протокол на съответния език",null);
      // }
      

      this.submit({});
      this.loading = false;
    });

  }


  editRequest(id) {
    const routeId = +this.route.snapshot.paramMap.get('id');
    this.requestService.editRequest(id).subscribe(data => {
      this.additional_notes = data.additional_notes,
        this.id = data.id
        this.batch = data.batch,
        this.proggress = data.proggress,
        this.get_protocol = data.get_protocol,
        this.express_order = data.express_order,
        this.price_all = parseFloat(data.price_all),
        this.product_id = data.product_id
        if (this.product_id) {
          this.getIndicators(this.product_id);
        }

      this.subProduct_id = data.subProduct_id,
        this.subSubProduct_id = data.subSubProduct_id,
        this.standpoint = data.standpoint,
        this.sort = data.sort,
        this.sort_ru = data.sort_ru,
        this.sort_en = data.sort_en,
        this.quantity_count = data.quantity_count,
        this.quantity = data.quantity,
        this.vintage = new Date(data.vintage)
      if (data.selIndicators !== undefined) {
        this.selIndicators = data.selIndicators;
        this.selIndicatorIds = data.selIndicatorsIds;
      } else {
        this.selIndicators = [];
        this.selIndicatorIds = [];
      }
        this.reference_number = data.reference_number,
        this.created_at = data.created_at,
        this.client_name = data.client_name,
        this.courier = data.courier,
        this.payment_type = data.payment_type,
        this.status = data.status,
        this.paid_part = data.paid_part,
        this.protocol_lang = data.protocol_lang != null ? data.protocol_lang : [],
        this.package_id = data.package_id,
        this.statusText = data.statusText
        this.protocol_town = data.protocol_town,
        this.protocol_address = data.protocol_address,
        this.protocol_person = data.protocol_person,
        this.protocol_phone = data.protocol_phone,
        this.standpointPages = data.standpointPages,
        this.submitted = true,
        this.allDocs = data.allDocs,
        this.requestDoc_id = data.requestDoc_id,
        this.invoice_id = data.invoice_id,
        this.proforma_id = data.proforma_id,
        this.kreditno_id = data.kreditno_id,
        this.debitno_id = data.debitno_id,
        this.protocol_id = data.protocol_id,
        this.batch_quantity = data.batch_quantity,
        this.product_info = data.product_info,
        this.declaration = new Date(data.declaration),
        this.sample_protocol = data.sample_protocol,
        this.sample_address = data.sample_address,
        this.sample_number = data.sample_number

      if (this.package_id != null && this.package_id != 0) {
        this.getPackIndicators(this.package_id);
      }
      this.bg = data.bg,
        this.en = data.en,
        this.ru = data.ru,
        this.courier_name = data.courier_name,
        this.clientSelected(data.client_name)
      if (data.product_id != undefined && data.product_id != 0) {
        this.product_id = data.product_id;
        this.subShow = true;
        this.getSubProds(data.product_id);
      }
      if (routeId) {
        this.client_id = data.client_id
      }
    });
  }

  //indicators modal

  openIndicatorDialog(): void {
    this.requestService.getModalIndicators(this.product_id).subscribe(data1 => {
      this.requestService.setModalIndicators(this.selIndicators);
      const dialogRef = this.dialog.open(IndicatorModal, {

        data: { indicators: data1, selectedIds: this.selIndicatorIds != undefined ? this.selIndicatorIds : [], fruitCtrl: this.fruitCtrl },

      });
      dialogRef.afterClosed().subscribe(result => {
        // console.log(result)
        // if (result != undefined) {
        this.selIndicators = this.requestService.modalIndicatorsGet();
        this.selIndicatorIds = this.requestService.getIndicatorsIds();
        this.getIndicatorPrice();


        // }
      });
    });

  }



}




@Component({
  selector: 'indicators',
  // styleUrls: ['../assets/css/humge.min.css'],
  templateUrl: 'indicators.html',
})
export class IndicatorModal {
  modalIndicators: any = [];
  selectedAll: any = [];
  selectedAllIds: any = [];
  constructor(
    public dialogRef: MatDialogRef<IndicatorModal>, private requestService: RequestService,
    @Inject(MAT_DIALOG_DATA) public data: IndicatorData) {
    if (this.requestService.modalIndicators != undefined) {
      this.selectedAll = this.requestService.modalIndicatorsGet();
      this.selectedAllIds = data.selectedIds;
    }

  }


  save() {

    this.requestService.setModalIndicators(this.selectedAll);
    this.requestService.setIndicatorsIds(this.selectedAllIds);
    this.dialogRef.close();
  }

  selIndicator(indicator) {
    var index = this.selectedAll.indexOf(indicator);

    if (index !== -1) {
      this.selectedAll.splice(index, 1);
      var idIndex = this.selectedAllIds.indexOf(indicator.id);
      this.selectedAllIds.splice(idIndex, 1);
    } else {
      this.selectedAll.push(indicator);
      this.selectedAllIds.push(indicator.id);
    }
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

}


@Component({
  selector: 'client-modal',
  // styleUrls: ['../assets/css/humge.min.css'],
  templateUrl: 'clientModal.html',
})
export class ClientModal {

  constructor(
    public dialogRef: MatDialogRef<ClientModal>,
    @Inject(MAT_DIALOG_DATA) public data: ClientModal) { 
      this.contractFunc();
    }

  contractFunc() {
    if (this.data.contract) {
      if ((!this.data.discount || this.data.discount == '0') || parseInt(this.data.discount) <= 5) {
        this.data.discount = '5';
      }
    } else {
      this.data.discount = '0';
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
